import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["Me", "Categories", "Campuses", "Vendors", "Items", "Users"],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/auth/login",
        method: "POST",
        body: credentials,
      }),
      invalidatesTags: ["Me"],
    }),
    logout: builder.mutation({
      query: () => ({
        url: "/auth/logout",
        method: "GET",
      }),
      invalidatesTags: ["Categories", "Campuses", "Vendors", "Items", "Users", "Me"],
    }),
    getMe: builder.query({
      providesTags: ["Me"],
      query: () => ({
        url: "/user/getme",
        method: "GET",
      }),
    }),
    updatePassword: builder.mutation({
      query: (data) => ({
        url: "/user/updatepassword",
        method: "PATCH",
        body: data,
      }),
    }),
    forgotPassword: builder.mutation({
      query: (email) => ({
        url: "/auth/forgotPassword",
        method: "POST",
        body: { email },
      }),
    }),
    changePasswordWithOtp: builder.mutation({
      query: (payload) => ({
        url: "/auth/changePasswordWithOtp",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useGetMeQuery,
  useUpdatePasswordMutation,
  useForgotPasswordMutation,
  useChangePasswordWithOtpMutation,
} = authApi;
